import React from 'react'

import { Icon } from 'src/chrome'

import styles from '../styles/components/Drawer.module.scss'

interface ImageControlsProps {
  id: string
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void
}

const ImageControls: React.FC<ImageControlsProps> = props => {
  const { id, onClick } = props
  return (
    <div className={styles.launchImageDrawer} id={id} onClick={onClick}>
      <Icon icon={'CAMERA2'} />
    </div>
  )
}

export default ImageControls
